export const PARAMS = {
    BOOKKEEPER_TRIP_HISTORY_TABLE_DEFAULT_COLUMNS: 'BOOKKEEPER_TRIP_HISTORY_TABLE_DEFAULT_COLUMNS',
    BUDGET_TABLE_DEFAULT_PAGE_SIZE: 'BUDGET_TABLE_DEFAULT_PAGE_SIZE',
    BUDGET_TYPES: 'BUDGET_TYPES',
    CALENDAR_START_DAY: 'CALENDAR_START_DAY',
    CALENDAR_START_YEAR: 'CALENDAR_START_YEAR',
    CASH_ADVANCE_TABLE_DEFAULT_PAGE_SIZE: 'CASH_ADVANCE_TABLE_DEFAULT_PAGE_SIZE',
    CLIENT_HISTORY_TABLE_COLUMNS: 'CLIENT_HISTORY_TABLE_COLUMNS',
    CLIENT_TABLE_DEFAULT_COLUMNS: 'CLIENT_TABLE_DEFAULT_COLUMNS',
    CLIENT_TABLE_DEFAULT_PAGE_SIZE: 'CLIENT_TABLE_DEFAULT_PAGE_SIZE',
    DAILY_TRIP_COMMON_EXPENSE: 'DAILY_TRIP_COMMON_EXPENSE',
    DAILY_TRIP_TABLE_DEFAULT_PAGE_SIZE: 'DAILY_TRIP_TABLE_DEFAULT_PAGE_SIZE',
    DAILY_TRIP_TABS_OPTION: 'DAILY_TRIP_TABS_OPTION',
    DAILY_TRIP_TABS_PENALTY_OPTION: 'DAILY_TRIP_TABS_PENALTY_OPTION',
    DEFAULT_USER_IDS: 'DEFAULT_USER_IDS',
    DRIVER_TRIP_HISTORY_TABLE_DEFAULT_COLUMNS: 'DRIVER_TRIP_HISTORY_TABLE_DEFAULT_COLUMNS',
    EXPENSE_TABLE_DEFAULT_PAGE_SIZE: 'EXPENSE_TABLE_DEFAULT_PAGE_SIZE',
    EXPENSE_TYPES: 'EXPENSE_TYPES',
    HELPER_TRIP_HISTORY_TABLE_DEFAULT_COLUMNS: 'HELPER_TRIP_HISTORY_TABLE_DEFAULT_COLUMNS',
    PAYROLL_TABLE_DEFAULT_COLUMNS: 'PAYROLL_TABLE_DEFULT_COLUMNS',
    SHIPPINGLINE_TABLE_DEFAULT_COLUMNS: 'SHIPPINGLINE_TABLE_DEFAULT_COLUMNS',
    SHIPPINGLINE_TABLE_DEFAULT_PAGE_SIZE: 'SHIPPINGLINE_TABLE_DEFAULT_PAGE_SIZE',
    TRIP_PAYMENT_TABLE_DEFAULT_PAGE_SIZE: 'TRIP_PAYMENT_TABLE_DEFAULT_PAGE_SIZE',
    TRIP_TABLE_DEFAULT_COLUMNS: 'TRIP_TABLE_DEFAULT_COLUMNS',
    TRIP_TABLE_DEFAULT_PAGE_SIZE: 'TRIP_TABLE_DEFAULT_PAGE_SIZE',
    USER_TABLE_DEFAULT_COLUMNS: 'USER_TABLE_DEFAULT_COLUMNS',
    USER_TABLE_DEFAULT_PAGE_SIZE: 'USER_TABLE_DEFAULT_PAGE_SIZE',
    VEHICLE_DAILY_TRIP_DEFAULT_TABLE_COLUMNS: 'VEHICLE_DAILY_TRIP_TABLE_COLUMNS',
    VEHICLE_EXPENSE_DEFAULT_TABLE_COLUMNS: 'VEHICLE_EXPENSE_TABLE_COLUMNS',
    VEHICLE_TABLE_DEFAULT_COLUMNS: 'VEHICLE_TABLE_DEFAULT_COLUMNS',
    VEHICLE_TABLE_DEFAULT_PAGE_SIZE: 'VEHICLE_TABLE_DEFAULT_PAGE_SIZE' 
}


// WEBPACK FOOTER //
// ./src/app/contants/PARAMS.ts